import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, from } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    // First check the current auth state
    return from(this.authService.checkAuthState()).pipe(
      map(isAuthenticated => {
        console.log('Auth guard check:', isAuthenticated);
        if (isAuthenticated) {
          return true;
        }
        this.authService.redirectUrl = this.router.routerState.snapshot.url;
        return this.router.createUrlTree(['/auth/login']);
      }),
      catchError(() => {
        console.error('Auth guard check failed');
        return from([this.router.createUrlTree(['/auth/login'])]);
      })
    );
  }
}